const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        coingeckoId: 'tether',
        decimals: 1e6,
        address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'tether',
        symbol: 'USDT',
        decimals: 1e6,
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
    },
    renbtc: {
        id: 'renbtc',
        coingeckoId: 'bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
    },
    eth: {
        id: 'eth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'ETH',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    weth: {
        id: 'weth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        coingeckoId: 'weth',
    },
    wsteth: {
        id: 'wsteth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'wstETH',
        decimals: 1e18,
        address: '0x5979D7b546E38E414F7E9822514be443A4800529',
        coingeckoId: 'wrapped-steth',
    },
    eurs: {
        id: 'eurs',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'stasis-eurs',
        symbol: 'EURs',
        decimals: 1e2,
        address: '0xd22a58f79e9481d1a88e00c343885a588b34b68b',
    },
    '2pool': {
        id: '2pool',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: '2Crv',
        decimals: 1e18,
        address: '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        isLpToken: true,
    },
};
